var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellnessB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9138 4.19466C10.2611 4.19466 7.29883 7.15581 7.29883 10.8089C7.29883 12.5753 7.957 14.2783 9.14492 15.5856L9.89131 16.407C10.1218 16.6607 10.2495 16.9911 10.2495 17.3338V17.8651H13.164V12.8104H12.4615C12.0471 12.8104 11.711 12.4744 11.711 12.0599C11.711 11.6454 12.0471 11.3094 12.4615 11.3094H15.3678C15.7823 11.3094 16.1183 11.6454 16.1183 12.0599C16.1183 12.4744 15.7823 12.8104 15.3678 12.8104H14.665V17.8651H17.6158V17.3293C17.6158 16.9876 17.7421 16.6579 17.9704 16.4036L18.7091 15.5806C19.8822 14.2736 20.5305 12.5756 20.5305 10.8205C20.5305 7.1682 17.5692 4.19466 13.9138 4.19466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.6144 19.3661H10.248V21.1592C10.248 22.8491 11.618 24.219 13.3078 24.219H14.5546C16.2445 24.219 17.6144 22.8491 17.6144 21.1592V19.3661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.11719 11.5979C3.11719 11.1834 3.45319 10.8474 3.8677 10.8474H4.98724C5.40173 10.8474 5.73776 11.1834 5.73776 11.5979C5.73776 12.0124 5.40173 12.3484 4.98724 12.3484H3.8677C3.45319 12.3484 3.11719 12.0124 3.11719 11.5979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.1094 11.5979C22.1094 11.1834 22.4454 10.8474 22.8599 10.8474H23.9794C24.3939 10.8474 24.7299 11.1834 24.7299 11.5979C24.7299 12.0124 24.3939 12.3484 23.9794 12.3484H22.8599C22.4454 12.3484 22.1094 12.0124 22.1094 11.5979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.56552 6.19504C4.77278 5.83606 5.23178 5.71306 5.59076 5.92032L6.56031 6.48009C6.91925 6.68735 7.04225 7.14635 6.83502 7.50532C6.62777 7.8643 6.16874 7.98727 5.80979 7.78004L4.84024 7.22024C4.48126 7.01301 4.35827 6.55399 4.56552 6.19504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.0108 15.6907C21.2181 15.3318 21.6771 15.2088 22.0361 15.416L23.0056 15.9758C23.3646 16.183 23.4876 16.642 23.2803 17.001C23.0731 17.36 22.6141 17.483 22.2551 17.2757L21.2855 16.7159C20.9266 16.5087 20.8036 16.0497 21.0108 15.6907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.56552 17.0008C4.35827 16.6418 4.48126 16.1828 4.84024 15.9755L5.80979 15.4158C6.16874 15.2085 6.62777 15.3315 6.835 15.6905C7.04225 16.0494 6.91926 16.5085 6.56031 16.7157L5.59076 17.2754C5.23178 17.4827 4.77278 17.3597 4.56552 17.0008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.0108 7.50507C20.8036 7.14612 20.9266 6.68709 21.2856 6.47983L22.2551 5.92006C22.6141 5.71283 23.0731 5.8358 23.2803 6.19478C23.4876 6.55376 23.3646 7.01276 23.0056 7.22001L22.0361 7.77978C21.6771 7.98701 21.2181 7.86404 21.0108 7.50507Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnessB);
export default __webpack_public_path__ + "static/media/wellness_b.3ba81765ff0af987a01d0c3fcbb70a18.svg";
export { ForwardRef as ReactComponent };